import React from 'react'

import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import QrCodesStore from '../../../QRCodes.store'
import { QRCodesViewFormStore } from '../QRCodesViewForm.store'

interface IProps {
  store: QRCodesViewFormStore
  qrCodesStore: QrCodesStore
}

@observer
export default class RegularFooter extends React.Component<IProps> {
  public render() {
    const {
      store: { isScannerPaused, pauseResumeScanner },
      qrCodesStore: { isActive, toggleEndRideConfirm, activateScanner },
    } = this.props

    return (
      <>
        {isActive ? (
          <>
            <Button
              variant={isScannerPaused ? 'default' : 'primary-outline'}
              className="medium-bold tw:grow"
              onClick={pauseResumeScanner}
            >
              {isScannerPaused
                ? Localization.translator.resumeScanner
                : Localization.translator.pauseScanner}
            </Button>
            <Button
              variant="default"
              className="ml8 medium-bold tw:grow"
              onClick={toggleEndRideConfirm}
            >
              {Localization.translator.endSessionForAll}
            </Button>
          </>
        ) : (
          <Button
            variant="default"
            className="medium-bold tw:grow"
            onClick={activateScanner}
          >
            {Localization.translator.startScanner}
          </Button>
        )}
      </>
    )
  }
}
